var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('homeHeader',{ref:"homeHeader"}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('homeFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }